// Refactored and cleaned-up version of ManageDepartment
import { Card, Col, Form, Row } from 'antd';
import {
  ButtonBack,
  ButtonSubmit,
  ButtonAdd,
  ButtonAction,
} from 'components/Common/Buttons';
import useTopbarTitleHooks from 'hooks/useTopbarTitleHooks';
import { useAtom } from 'jotai';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_ROUTE_PREFIX, RouteConstant } from 'routes/routesConstant';
import useDeptRepo from 'services/repo/useDepartmentRepo';
import useOrgRepo from 'services/repo/useOrgRepo';
import useDivRepo from 'services/repo/useDivisionRepo';
import {
  INIT_DEPARTMENT,
  departmentAtom,
} from 'store/Department/department';
import { PRIVILEGE_ID } from 'utils/AccessPermissionConfig';
import Constant from 'utils/Constants';
import CustomAlert from 'utils/CustomAlert';
import {
  checkErrorFormToOpenCollapse,
  setFieldValues,
} from 'utils/Helper';
import {
  dismissToast,
  errorToast,
  loadingToastId,
  successToast,
} from 'utils/Toast';
import {
  CustomFormItemText,
  CustomFormItemSelectDropdown,
  CustomFormItemSwitch,
} from 'components/Common/CustomFormItem';
import { CustomAntdTableTemp } from 'components/Common/CustomAntdTableTemp';

export default function ManageDepartment() {
  const { deptId } = useParams();
  const navigate = useNavigate();
  useTopbarTitleHooks(`${deptId ? 'Edit' : 'Create'} Department`);


  const {
    isLoading: isLoadingSave,
    createDepartment,
    updateDepartment,
    getDepartmentById,
  } = useDeptRepo(false);

  const { getOrgList } = useOrgRepo();
  const { getDivisionList } = useDivRepo();
  const [dataField, setDataField] = useAtom(departmentAtom);
  const [departmentList, setDepartmentList] = useState([]);
  const [orgOptions, setOrgOptions] = useState([]);
  const [divOptions, setDivOptions] = useState([]);
  const [form] = Form.useForm();
  const isLoadingPrivilege = useRef(true);

  const [filters, setFilters] = useState({
    orgId: null,
    divId: null,
  })

  const [tableParams, setTableParams] = useState({
    pageNumber: 1,
    pageSize: 10,
    filter: { ...filters },
    orderBy: "divName",
    isAscending: true
  });



  const fetchDataOrg = async () => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      orderBy: "orgId",
      isAscending: true,
      filter: {
        orgId: null,
        orgName: "",
        status: "true",
      },
    }

    const res = await getOrgList(payload)
    if (res?.detail == 'OK' && res?.status === 200) {

      const options = res.data.content.map(item => ({
        label: item?.orgName,
        value: item?.orgId,
      }));
      setOrgOptions(options);

      if (options.length === 1) {
        const onlyOption = options[0];
        setDataField(prev => ({ ...prev, orgId: onlyOption.value }));

        form.setFieldsValue({ orgId: onlyOption.value }); // isinya harus { label, value }
        setFilters((prev) => ({ ...prev, orgId: onlyOption.value }));

        setTableParams((prev) => ({
          ...prev,
          filter: {
            ...prev.filter,
            orgId: onlyOption.value
          }
        }));
        fetchDataDivision(onlyOption.value);
      }
    }
  }

  const fetchDataDivision = async (orgId) => {
    const payload = {
      pageNumber: 1,
      pageSize: 0,
      filter: {
        divCode: "",
        divName: "",
        orgId: orgId,
        divId: null,
        status: "true",
      },
      orderBy: "divCode",
      isAscending: true
    }
    setDivOptions([])

    const res = await getDivisionList(payload)
    if (res?.detail == 'OK' && res?.status === 200) {
      setDivOptions(() => {
        return res?.data?.content.map(item => {
          return {
            value: item?.divId,
            label: item?.divName
          }
        })
      })
    }
  }

  const fetchGetDepartmentById = async id => {


    const res = await getDepartmentById({ deptId: id });

    if (res?.detail === 'OK') {
      const data = res.data;
      console.log('data = ', JSON.stringify(data))
      
      setDataField(prev => ({
        ...prev,
        deptId: data.deptId,
        orgId: data.orgId,
        divId: data.divId,
        deptCode: data.deptCode,
        deptName: data.deptName,
        status: String(data.status).toLowerCase() === 'true',
      }));

      // isi form (pakai labelInValue untuk Select)
      form.setFieldsValue({
        orgId: { value: data.orgId, label: data.orgName },
        divId: { value: data.divId, label: data.divName },
        deptCode: data.deptCode,
        deptName: data.deptName,
        status: String(data.status).toLowerCase() === 'true',
      });


      fetchDataDivision(data.orgId);
    }
  };


  const pickVal = (x) => (x && typeof x === 'object' ? (x.value ?? null) : (x ?? null));

  const handleAddDepartment = async () => {

    await form.validateFields(['orgId', 'divId', 'deptName']);
    const latestStatus = form.getFieldValue("status");
    const v = form.getFieldsValue();
    const orgVal = pickVal(v.orgId);
    const divVal = pickVal(v.divId);

    if (!orgVal || !divVal) return errorToast('Organization & Division are required.');

    const newItem = {
      id: Date.now(),
      orgId: orgVal,
      divId: divVal,
      orgName: orgOptions.find(o => o.value === orgVal)?.label || '',
      divName: divOptions.find(d => d.value === divVal)?.label || '',
      deptCode: String(v.deptCode || '').trim(),
      deptName: String(v.deptName || '').trim(),
      status: latestStatus,
    };


    setDepartmentList(prev => [...prev, newItem]);

    setDataField({ ...INIT_DEPARTMENT, status: true })

    form.resetFields(['divId', 'deptCode', 'deptName']);
    form.setFieldsValue({ status: true });


  };

  const handleFormSubmit = e => {
    e.preventDefault();
    CustomAlert.confirm({
      title: 'Submit Department!',
      description: 'Are you sure you want to submit this data?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      type: 'primary',
      onConfirmButton: () => {
        if (deptId) {
          doUpdate(); // Mode Edit
        } else {
          validateSubmit(); // Mode Create
        }
      },
    });
  };

  const validateSubmit = () => {
    if (departmentList.length === 0) return errorToast('Please add at least one department.');
    doSubmit();
  };

  const doSubmit = async () => {
    const orgId = departmentList[0].orgId;
    const hasMixedOrg = departmentList.some(item => item.orgId !== orgId);
    if (hasMixedOrg) return errorToast('All departments must belong to the same organization.');

    const payloadData = {
      orgId,
      deptList: departmentList.map(item => ({
        divId: item.divId,
        deptCode: item.deptCode,
        deptName: item.deptName,
        status: String(item.status),
      })),
    };

    loadingToastId(Constant.message.savingData, payloadData);
    const response = await createDepartment(payloadData);
    dismissToast(payloadData);

    if (response?.detail === 'OK') {
      successToast(Constant.message.saveDataSuccess);
      navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.department.index}`, { replace: true });
    } else {
      errorToast(Constant.message.errorSave);
    }
  };

  const doUpdate = async () => {
    form.validateFields().then(async () => {

      const v = form.getFieldsValue(); // ambil nilai terkini dari Form

      const payload = {
        deptId: dataField?.deptId,
        orgId: v.orgId?.value ?? dataField.orgId ?? null,  // labelInValue → .value
        divId: v.divId?.value ?? dataField.divId ?? null,
        deptCode: String(v.deptCode ?? '').trim(),
        deptName: String(v.deptName ?? '').trim(),
        status: String(!!v.status),
      };

      console.log('payload = ', payload)

      loadingToastId(Constant.message.savingData, payload);
      const response = await updateDepartment(payload);
      dismissToast(payload);

      if (response?.detail === 'OK') {
        successToast(Constant.message.saveDataSuccess);
        navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.department.index}`, { replace: true });
      } else {
        errorToast(Constant.message.errorSave);
      }
    }).catch(() => errorToast(Constant.message.errorForm));
  };


  const columns = [
    { title: 'Organization', dataIndex: 'orgName' },
    { title: 'Division', dataIndex: 'divName' },
    { title: 'Code', dataIndex: 'deptCode' },
    { title: 'Name', dataIndex: 'deptName' },
    {
      title: 'Status',
      dataIndex: 'status',
      render: val => (val ? 'Active' : 'Inactive'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, row) => (
        <ButtonAction buttons={['delete']} onDelete={() => setDepartmentList(prev => prev.filter(item => item.id !== row.id))} />
      ),
    },
  ];



  const fetchCheckPrivilege = async () => {
    loadingToastId(Constant.message.loading, PRIVILEGE_ID.AddEditDepartment)
    dismissToast(PRIVILEGE_ID.AddEditDepartment)
    if (deptId) await fetchGetDepartmentById(deptId)
    isLoadingPrivilege.current = false
  }
  useEffect(() => {
    fetchDataOrg();
    fetchCheckPrivilege()

    if (deptId) {
      // Jika edit, maka pastikan list kosong
      setDepartmentList([]);
    } else {
      setDataField(INIT_DEPARTMENT); // ✅ akan bawa status = 'true'
      form.setFieldsValue({ status: true }); // ✅ sinkron dengan default
    }
    // return () => setDataField(INIT_DEPARTMENT);
  }, [deptId]);

  return (
    <Card>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
      >
        <Row gutter={[16]}>
          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="orgId"
              label="Organization"
              showSearch
              value={dataField?.orgId}
              rules={[{ required: true }]}
              placeholder="Select Organization"
              loading={false}
              options={orgOptions}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }

              onChange={(value) => {
                setFilters((prev) => ({
                  ...prev,
                  orgId: value || null,
                  divId: null
                }));
                form.setFieldsValue({ divId: undefined });
                if (value) fetchDataDivision(value);
                else setDivOptions([]);
              }}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemSelectDropdown
              nameFormItem="divId"
              label="Division"
              showSearch
              value={dataField?.divId}
              rules={[{ required: true }]}
              placeholder="Select Division"
              options={divOptions}
              onChange={(value) => {
                setDataField((prev) => ({
                  ...prev,
                  divId: value || null,
                }));

              }}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemText
              nameFormItem="deptCode"
              label="Code"
              placeholder="Fill in Department Code"
              rules={[{ required: false }]}
              value={dataField?.deptCode}
              onChange={e => setDataField(prev => ({ ...prev, deptCode: e.target.value }))}
            />
          </Col>

          <Col xs={24}>
            <CustomFormItemText
              nameFormItem="deptName"
              label="Name"
              placeholder="Fill in Department Name"
              rules={[{ required: true }]}
              value={dataField?.deptName}
              onChange={e => setDataField(prev => ({ ...prev, deptName: e.target.value }))}
            />
          </Col>

          <Col xs={24} sm={24} lg={12}>
            <CustomFormItemSwitch
              nameFormItem="status"
              label="Is Active"
              value={dataField?.status}
              onChange={checked => setDataField(prev => ({ ...prev, status: checked }))}
            />
          </Col>

          {!deptId && (
            <>
              <Col span={24} offset={6}>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <ButtonAdd className="button-custom btn-gray" buttonText="Add" onClick={handleAddDepartment} />
                </div>
              </Col>

              <Col span={24}>
                <div style={{ marginTop: 24 }}>
                  <CustomAntdTableTemp columns={columns} dataSource={departmentList} rowKey="id" pagination={false} />
                </div>
              </Col>
            </>
          )}

          <Col span={24} offset={6}>
            <div style={{ display: 'flex', gap: '10px', margin: '10px 0' }}>
              <ButtonBack
                onClick={() => navigate(`${APP_ROUTE_PREFIX}/${RouteConstant.organization.department.index}`)}
                disabled={isLoadingPrivilege.current || isLoadingSave}
              />
              <ButtonSubmit
                onClick={handleFormSubmit}
                loading={isLoadingSave}
                disabled={
                  (!deptId && departmentList.length === 0) || isLoadingPrivilege.current || isLoadingSave
                }
              // disabled={departmentList.length === 0 || isLoadingPrivilege.current || isLoadingSave}
              />
            </div>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
